import moment, { Moment } from "moment";
import { DATE_FORMAT, DB_DATE_FORMAT } from "../constants/global.constants";

export const formatDate = (
  date?: string | Date,
  format: string = DATE_FORMAT,
) => {
  return moment(date || new Date()).format(format);
};

export const formatTime = (date?: string | Date, format: string = "h:mm A") => {
  return moment(date || new Date()).format(format);
};

export const formatOnlyTime = (
  time: string,
  defaultFormat: string = "h:mm:ss",
  format: string = "h:mm A",
) => {
  return moment(time, defaultFormat).format(format);
};

export const convertMinutesToHours = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}:${remainingMinutes.toString().padStart(2, "0")}`;
};

export function convertMinutesToHoursWithText(minutes: number): string {
  const duration = moment.duration(minutes, "minutes");
  const hours = Math.floor(duration.asHours());
  const mins = duration.minutes();

  return !minutes
    ? "0"
    : `${
        hours
          ? `${hours} hr${hours !== 1 ? "s" : ""} ${mins ? "and" : ""} `
          : ""
      }${mins ? `${mins} min` : ""} `;
}

// calculate just minutes
export const calculateMinutes = (startTime: string, endTime: string) => {
  const start = moment(startTime, "h:mm A");
  const end = moment(endTime, "h:mm A");

  return end.diff(start, "minutes");
};

export const getTimeDurationInDays = (
  startDate: string,
  endDate: string,
): number => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const diffInMilliseconds = end.getTime() - start.getTime();
  const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);

  return Math.round(diffInDays);
};

export const formatMinutesToHours = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const minute = minutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
};

export const formatSecondToMinutes = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
};

export const isExpired = (expirationDate: string, format = DB_DATE_FORMAT) => {
  const currentDate = moment();
  const date = moment(expirationDate).format(format);
  return moment(date, format).isBefore(currentDate);
};

export const disableTodayAndFutureDates = (current: any) => {
  return current && current >= moment().startOf("day");
};

export const disableFutureDates = (current: any) => {
  return current && current > moment().endOf("day");
};

export const disablePastDates = (current: any) => {
  return current && current < moment().startOf("day");
};

export const getLastTenYears = (): string[] => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 11 }, (_, index) =>
    (currentYear - index).toString(),
  );
};

export const convertMinutesToTime = (minutes: number = 0) => {
  const duration = moment.duration(minutes, "minutes");

  const hours = Math.floor(duration.asHours());
  const mins = duration.minutes();

  return `${hours}:${mins.toString().padStart(2, "0")}`;
};

export const formatUTCTime = (date: string | Moment) => {
  return moment.utc(date).local().toISOString();
};
export const formatUTCDate = (
  date: string | Moment,
  format = "DD MMM, YYYY",
) => {
  return moment.utc(date).format(format);
};

export const UTCTimeFormat = (date: string | Moment, format = "hh:mm A") => {
  return moment.utc(date).format(format);
};

export const getStartAndEndDateInAMonth = (
  date: Date,
  format = DB_DATE_FORMAT,
) => {
  return {
    startDate: moment(date).startOf("month").format(format),
    endDate: moment(date).endOf("month").format(format),
  };
};
